import { render, staticRenderFns } from "./StudentInformation.vue?vue&type=template&id=53de8d3f&scoped=true&lang=pug&"
import script from "./StudentInformation.vue?vue&type=script&lang=ts&"
export * from "./StudentInformation.vue?vue&type=script&lang=ts&"
import style0 from "./StudentInformation.vue?vue&type=style&index=0&id=53de8d3f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53de8d3f",
  null
  
)

export default component.exports